export default class MyAccountRegister {
    constructor() {
        this.registerContainer = document.querySelector(
            ".my-account__register"
        );

        if (this.registerContainer) {
            this.events();
        }
    }

    events() {
        // this.initializeRecaptcha();
    }

    initializeRecaptcha() {
        // eslint-disable-next-line no-undef
        grecaptcha.ready(() => {
            // eslint-disable-next-line no-undef
            grecaptcha
                .execute(window.global.recaptcha_site_key, {
                    action: "registerUser",
                })
                .then((token) => {
                    document.querySelector("#recaptchaResponseRegister").value =
                        token;
                });
        });
    }
}
